<template>
  <div>
    <Header />

    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/bannerServicios.jpg')"
          :lazy-src="require('@/assets/carruselLazyLoad.jpg')"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-col>

      <v-breadcrumbs :items="itemsBreadCrumbs" large>
        <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-sheet class="mx-auto" elevation="0" width="100%">
      <v-slide-group v-model="model" class="pa-4" show-arrows center-active>
        <v-slide-item
          v-for="(item, n) in itemServicios"
          :key="n"
          v-slot:default="{ active, toggle }"
        >
          <v-card
            class="ma-4"
            height="300"
            width="300"
            @click="toggle"
            content="Dar click!"
            v-tippy="{ arrow: true, arrowType: 'round' }"
          >
            <v-img
              :src="item.img"
              height="100%"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            >
              <v-row align="end" class="lightbox white--text pa-2 fill-height">
                <v-col>
                  <div class="subheading">
                    {{ item.title }}
                  </div>
                </v-col>
              </v-row>
            </v-img>
            <v-scale-transition>
              <v-icon v-if="active" color="white" size="48"></v-icon>
            </v-scale-transition>
          </v-card>
        </v-slide-item>
      </v-slide-group>
      <v-expand-transition>
        <v-sheet
          v-if="model != null"
          color="lighten-4"
          height="auto"
          width="100%"
        >
          <v-container fluid>
            <v-row class="d-flex justify-space-around">
              <v-col cols="12" md="4" align-self="center">
                <v-card tile>
                  <v-img
                    aspect-ratio="1.7"
                    :src="this.itemServicios[model].img"
                  ></v-img>
                </v-card>
              </v-col>

              <v-col cols="12" md="4" align-self="center">
                <v-card tile elevation="0" class="text-justify">
                  <v-card-title class="fontTitle">{{
                    this.itemServicios[model].title
                  }}</v-card-title>
                  <v-card-text class="subfont">{{
                    this.itemServicios[model].descripcion
                  }}</v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="4" align-self="center">
                <v-card elevation="0" class="pt-3 text-justify">
                  <v-card-title class="fontTitle">{{
                    this.itemServicios[model].tipoServicios
                  }}</v-card-title>
                  <v-card-text
                    class="subtitle-2 pa-0"
                    v-for="(otros, n) in itemServicios[model].otrosServicios"
                    :key="n"
                  > -{{ otros.tipo }}</v-card-text>
                  <v-card-actions>
                    <v-btn dark color="#0071E3" :to="{ name: 'OtrosServicios' }"
                      >Ver otros servicios</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-expand-transition>
    </v-sheet>

    <ButtonScroll />
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ButtonScroll from "../components/ButtonScroll.vue";

export default {
  components: {
    Header,
    Footer,
    ButtonScroll,
  },
  data: () => ({
    itemsBreadCrumbs: [
      {
        text: "HOME",
        disabled: false,
        href: "/",
      },
      {
        text: "NUESTROS SERVICIOS",
        disabled: true,
        href: "",
      },
    ],
    tab: null,
    itemServicios: [
      {
        title: "Asistencia de traslado medico",
        descripcion:
          "Servicios de traslado en ambulancia por accidente de tránsito con red de proveedores a nivel regional.",
        tipoServicios: "Otros servicios",
        img: require("@/assets/servicioAmbulancia.jpg"),
      },
      {
        title: "Inspección de accidentes",
        descripcion:
          "Cobertura regional, tiempos de contacto y respuesta cortos, envío de información rápida en linea utilizando tecnología de punta, informes técnicos.",
        tipoServicios: "Otros servicios",
        img: require("@/assets/servicioInspecAccidente.jpg"),
      },
      {
        title: "Asistencia legal",
        descripcion:
          "Red de abogados y notarios con amplia cobertura en la región Centroamericana especialistas en derecho penal y tránsito con disponibilidad las 24 horas del día los 365 días del año. Ubicados en zonas estratégicas previamente identificado por ser zona de Tránsito internacional.",
        tipoServicios: "Otros servicios",
        otrosServicios: [
          {
            tipo: "Asistencia legal por robo total o parcial más inspección de daños- proveedor interno",
          },
          {
            tipo: "Asistencia legal por robo total o parcial más inspección de daños- proveedor externo",
          },
          {
            tipo: "Asistencia legal hasta la audiencia inicial con lesiones en terceros con proveedor interno o externo",
          },
          {
            tipo: "Asistencia legal hasta la audiencia inicial por homicidio con proveedor interno o externo",
          },
          {
            tipo: "Asistencia legal por lesiones u homicidio concluido en proceso penal despues de la audiencia inicial",
          },
        ],
        img: require("@/assets/servicioLegal.jpg"),
      },
      {
        title: "Asistencia vial",
        descripcion:
          "Asistencia víal, es rápidez, responsabilidad y eficiencia en el servicio para nuestros clientes. Una completa red de proveedores a lo largo y ancho de toda la región, nuestros servicios de grúas y asistencia técnica de mecánicos en terreno permite que el producto sea versátil y fexible pensando en la comodidad de los clientes. Siempre queremos ir más allá para entregar un servicio de calidad.",
        tipoServicios: "Otros servicios",
        otrosServicios: [
          { tipo: "Remolque de vehículo" },
          { tipo: "Cambio de llanta" },
          { tipo: "Suministro de combustible" },
          { tipo: "Paso de corriente al vehículo" },
          { tipo: "Cerrajería vial-proveedor interno" },
          { tipo: "Cerrajería vial-proveedor externo" },
        ],
        img: require("@/assets/servicioVial.jpg"),
      },
      {
        title: "Conductor designado",
        descripcion:
          "Conductores certificados en manejo en la defensiva y excelente servicio al cliente.",
        tipoServicios: "Otros servicios",
        img: require("@/assets/servicioCondDesignado.jpg"),
      },
      {
        title: "Avanzada motorizada",
        descripcion:
          "Servicio innovador por su rápidez para contactar en el lugar del accidente superando el tráfico de la ciudad.",
        tipoServicios: "Otros servicios",
        img: require("@/assets/servicioMotorizada.jpg"),
      },
      {
        title: "Asistencia hogar",
        descripcion:
          "PLOMERÍA, ELECTRICIDAD, VIDRIERÍA, JARDINERÍA, CONSULTORÍA, TELEFÓNICA, FAMILIA, INQUILINATO.",
        tipoServicios: "Otros servicios",
        img: require("@/assets/servicioHogar.jpg"),
      },
      {
        title: "Plataforma talleres",
        descripcion:
          "La asistencia pone a disposición de su cliente la red de talleres a nivel regional, para remitir a los asegurados y terceros afectados para reparación y valuos.",
        tipoServicios: "Otros servicios",
        img: require("@/assets/servicioTalleres.jpg"),
      },
      {
        title: "Ajuste de presupuesto",
        descripcion:
          "Contamos con equipo de peritos evaluadores de los presupuestos de reparación brindados por los talleres y nuestro compromiso es optimizar los recursos de nuestro cliente.",
        tipoServicios: "Otros servicios",
        img: require("@/assets/servicioPresupuesto.jpg"),
      },
    ],
    model: null,
  }),
  created() {},
  methods: {},
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Zilla+Slab:ital,wght@1,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=EB+Garamond:wght@500&family=Zilla+Slab:ital,wght@1,700&display=swap");

.fontTitle {
  font-family: "Zilla Slab", serif;
  font-size: 35px;
}
.subfont {
  font-family: "EB Garamond", serif;
  font-size: 25px;
}
</style>
